// extracted by mini-css-extract-plugin
module.exports = {"c1ciwb2s":"c1ciwb2s","l113w4cp":"l113w4cp"};